import React, { useState } from 'react'
import HomePage2 from 'pages/HomePage2'

const MifabHome = () => {
  // const [showMenu, setShowMenu] = useState();
  // const onMenuOpen = () => {
  //   setShowMenu(!showMenu);
  // }
  return (
    <div className='wrapper'>
        {/* <Header onMenuOpen={onMenuOpen} isOpen={showMenu} /> */}
        <main id='contentBox'>
          <HomePage2 />
        </main>
    </div>
  )
}

export default MifabHome